import { render, staticRenderFns } from "./RewardBonusHistory.vue?vue&type=template&id=1dfddd92&"
import script from "./RewardBonusHistory.vue?vue&type=script&lang=js&"
export * from "./RewardBonusHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports